module.exports = __webpack_public_path__ + "static/media/tab-bg.5e3b8400.svg";